import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { CLIENT_SEARCH_MIN_LENGTH } from '../../../config/constants';
import { useDebounce } from '../../../hooks/useDebounce';
import i18n from '../../../i18n/i18nextInit';
import { showErrorToast } from '../../../utils/toastUtils';
import { type PartnerSearchResultDto, searchPartnersByTerm } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useSearchPartnerByTerm(searchTerm: string): UseQueryResult<PartnerSearchResultDto[], AxiosError> {
    const debouncedSearchTerm = useDebounce(searchTerm);
    const queryKey = useMemo(() => queryKeys.searchPartnerByTerm(debouncedSearchTerm), [debouncedSearchTerm]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => {
            try {
                return searchPartnersByTerm({ query: { searchTerm: debouncedSearchTerm }, signal }).then((result) => result.data);
            } catch (error) {
                showErrorToast({ error, userMessage: i18n.t('failureClientsSearch') });

                return [];
            }
        },
        enabled: debouncedSearchTerm.length >= CLIENT_SEARCH_MIN_LENGTH,
    });
}
